import React from "react";
import TextModal from "../TextModal";

const strings = {
    sayToCustomer: "Say to customer:",
    allergyWarning:
        "Please know that due to our preparation process, we cannot guarantee that allergens are not present in the food.",
    ok: "Ok",
};

type Props = {
    onClose: () => void;
};

export default function AllergyWarningModal(props: Props) {
    return (
        <TextModal
            title={strings.sayToCustomer}
            content={strings.allergyWarning}
            onClose={props.onClose}
            cancelLabel={strings.ok}
        />
    );
}
